import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import routes from "../../../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    Item,
    Toolbar,
    ColumnHeaderFilter,
    ColumnChooser,
    Selection,
    StateStoring,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
} from "devextreme-react/data-grid";
import { GridLayout } from "../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { ItemTypes } from "../../../../enum/Enum";
function LocationsTab(props) {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const gridKey = "423BADA8-5934-4DB2-A7AE-EC92E5153432";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const resultData = useMemo(() => {
        if (!props.formFields?.RowId) {
            return null;
        }
        return createStore({
            key: 'rLocation',
            loadParams:
            {
                id: function () {
                    return props.formFields?.RowId;
                },
                type: function () {
                    return 'item';
                },
                sort: JSON.stringify([{ selector: "locationCode", desc: false }])
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Location.GetLocationsByType}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        })
    }, [props.formFields?.RowId]);

    return (
        <div className="FormMt">

            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={resultData}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className={"GridHeightTabPanel-with-toolbar"}
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <ColumnHeaderFilter />
                <LoadPanel enabled={true} />
                <Paging defaultPageSize={10} />
                <Sorting visible={true} mode="multiple" />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50, 300, 500, 'all']}
                    showNavigationButtons={true}
                />
                <Column dataField="warehouse" caption="WH" dataType="string" />
                <Column dataField="locationCode" caption="Location" dataType="string" />
                <Column dataField="onHand" caption="On-Hand" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="inReceiving" caption="In-Receving" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="outShipped" caption="In-Shipping" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="outUnavailable" caption="Unavailable" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="available" caption="Available" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="inOrdered" caption="Pending Rec" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="outOrdered" caption="Pending Ship" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="netAvailable" caption="Net Available" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="inFuture" caption="Future Rec" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="outFuture" caption="Future Ship" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="parentLocation" caption="Parent Location" dataType="string" />
                <GridToolbar>
                    <GridToolbarItem location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </GridToolbarItem>
                    <GridToolbarItem name="exportButton" />
                    <GridToolbarItem name="columnChooserButton" />
                </GridToolbar>
            </DataGrid>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(LocationsTab);